import PropTypes from 'prop-types';

import {
  BaseDefaultProps,
  BasePropTypes,
} from '@/common/proptypes/Base/Base.proptypes';

export const ContentDefaultProps = {
  ...BaseDefaultProps,
  cart: {},
  currentItems: [],
  isUpdated: false,
};

export const ContentPropTypes = {
  ...BasePropTypes,
  cart: PropTypes.shape({
    discount_classes: PropTypes.arrayOf(PropTypes.shape({}), PropTypes.number),
  }),
  currentItems: PropTypes.arrayOf(PropTypes.shape({})),
  isUpdated: PropTypes.bool,
  onModify: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};
